import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import * as actions from "../../../store/appointments/actions";
import { injectIntl } from "react-intl";
import './style.scss';
import { useSelector } from "react-redux";

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const { appointmentReasons } = useSelector((state) => state.appointments);
  const [appointmentReasonsOptions, setAppointmentReasonsOptions] = useState([]);
  
  const payload = { page: 1, appointmentStatus: 5, sort: "id,desc" };
  const initialValues = {
    search: "",
    appointmentReasonId: 0,
  };
  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    appointmentReasonId: Yup.object().nullable(),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });

  useEffect(() => {
    dispatch(actions.getAppointmentReasonsRequest());
  }, [dispatch]);

  useEffect(() => {
    if (appointmentReasons) {
      setAppointmentReasonsOptions([
        { id: 0, reason: messages.appointments.all_reasons },
        ...appointmentReasons.filter(app => app.type === 2)
      ]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentReasons]);
  

  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: e.target.value, appointmentReasonId: formik.values.appointmentReasonId });
    dispatch(
      actions?.getMyAppointmentsRequest({
        ...payload,
        appointmentReasonId: formik.values.appointmentReasonId,
        search: e.target.value,
      })
    );
    // setSearchValues({ ...formik.values });
  };

  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, appointmentReasonId: e.target.value });
    dispatch(
      actions?.getMyAppointmentsRequest({
        ...payload,
        ...formik.values,
        appointmentReasonId: e.target.value,
      })
    );
  };
 

  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.appointments.search}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="appointmentReasonId"
              list={appointmentReasonsOptions}
              keyName="reason"
              valueKeyName="id"
              value={formik.values.appointmentReasonId}
              handleChange={(e) => searchWithSelect(e, "appointmentReasonId")}
              error={formik.errors.appointmentReasonId}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
